import { useState } from 'react';

// services
import { wpAjax } from '../services/api';

const useFuses = () => {
  const [fuses, setFuses] = useState([]);
  const [isFetchingFuses, setIsFetchingFuses] = useState(false);

  const fetchFuses = async () => {
    setIsFetchingFuses(true);
    try {
      const data = await wpAjax('fl_fetch_fuses');
      setFuses(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to fetch fuses:', error.message);
      setFuses([]);
    } finally {
      setIsFetchingFuses(false);
    }
  };

  const updateFuse = async (fuse) => {
    const params = {};

    // Scalar values
    Object.keys(fuse).forEach((key) => {
      if (!Array.isArray(fuse[key])) {
        params[key] =
          key === 'ignition_context' && typeof fuse[key] === 'object'
            ? JSON.stringify(fuse[key])
            : fuse[key];
      }
    });

    // Nested fuse_ideas
    if (Array.isArray(fuse.fuse_ideas)) {
      fuse.fuse_ideas.forEach((idea, index) => {
        params[`fuse_ideas[${index}][fuse_idea]`] = idea.fuse_idea;
        if (Array.isArray(idea.content_ideas)) {
          idea.content_ideas.forEach((content, contentIndex) => {
            params[
              `fuse_ideas[${index}][content_ideas][${contentIndex}][idea_content]`
            ] = content.idea_content;
            params[
              `fuse_ideas[${index}][content_ideas][${contentIndex}][idea_image_url]`
            ] = content.idea_image_url;
            params[
              `fuse_ideas[${index}][content_ideas][${contentIndex}][pinned]`
            ] = content.pinned;
          });
        }
      });
    }

    try {
      await wpAjax('fl_update_fuse', params);
      fetchFuses();
    } catch (error) {
      console.error('Failed to update fuse:', error.message);
    }
  };

  const deleteFuse = async (fuseID) => {
    setFuses((prev) =>
      prev.map((f) => (f.ID === fuseID ? { ...f, isDeleting: true } : f))
    );

    try {
      await wpAjax('fl_delete_fuse', { post_id: fuseID });
      fetchFuses();
    } catch (error) {
      console.error('Failed to delete fuse:', error.message);
    }
  };

  const deleteFuses = async (fuseIDs) => {
    setFuses((prev) =>
      prev.map((f) => (fuseIDs.includes(f.ID) ? { ...f, isDeleting: true } : f))
    );

    try {
      await wpAjax('fl_delete_fuses', {
        post_ids: JSON.stringify(fuseIDs)
      });
      fetchFuses();
    } catch (error) {
      console.error('Failed to delete fuses:', error.message);
    }
  };

  return {
    fuses,
    // setFuses,
    fetchFuses,
    isFetchingFuses,
    updateFuse,
    deleteFuse,
    deleteFuses
  };
};

export default useFuses;
